import React from 'react';
import styled from 'styled-components';
import Icon from '../../containers/assets/error-icon-small.png';

const AlertWrapper = styled.div`
  background: #faeded;
  border: 1px solid #ec5e59;
  border-radius: 4px;
  width: calc(100% - 40px);
  margin-bottom: 10px;
  max-width: 800px;
  padding: 9px 16px 15px 9px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);

  b {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }

  ${p => p.marginTop && `
    margin-top: ${p.marginTop}px;
  `}

  ${p => p.marginBottom && `
    margin-bottom: ${p.marginBottom}px;
  `}
`;

const AlertBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: flex-start;
  justify-content: flex-start;
`;

const FullWidth = styled.div`
  flex: 1;
`;

const ErrorInlineAlert = ({ title, message, marginTop, marginBottom }) => (
  <AlertWrapper marginTop={marginTop} marginBottom={marginBottom} className='inline-error'>
    <AlertBody>
      <div><img src={Icon} alt="" /></div>
      <FullWidth>
        <b>{title}</b><br />
        {message}
      </FullWidth>
    </AlertBody>
  </AlertWrapper>
);

export default ErrorInlineAlert;



// WEBPACK FOOTER //
// ./src/components/alerts/errorInline.js